import * as React from 'react';
import Logo from '../../../assets/SVG/nexxt-logo';
import { Link } from 'react-router-dom';
import { STATIC_STORAGE_URL } from '@nexxt/common/constants';

const PageUnderConstruction = () => (
    <div className="error-container">
        <div className="error-block">
            <div className="error-block__logo">
                <Logo />
            </div>
            <div className="error-block__content">
                <img src={`${STATIC_STORAGE_URL}/img/portal/error-img.png`} />
                <span className="error-block__title">
                    Oops! We are currently working on this page.
                </span>
                <p className="error-block__text">
                    Please go back and enjoy our service!
                </p>
                <Link className="btn btn--teal-blue" to="/">
                    Go to home
                </Link>
            </div>
        </div>
    </div>
);
export default PageUnderConstruction;
